export enum MinerBulkActions {
  StatusUpdate = 'Status Update',
  OutboundContainerAssignment = 'Outbound Container Assignment',
  CompleteServices = 'Complete Services',
  Consolidate = 'Consolidate',
  WorkOrderMovement = 'Work Order Movement',
}
